import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as routes from '../constants/routes';
import { handleUserLogout } from '../reducers';

const Logout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(handleUserLogout());
  }, [dispatch]);
  return <Redirect to={routes.LANDING} />;
};

export default Logout;
